import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => {
  return {
    headerContainer: {
      height: 'auto',
    },
    headerSubtitle: {
      maxWidth: '650px',
    },
  };
});

export default styles;
